import React from "react";

// Code-drawn logo: tilted navy rounded square with three lime wave bars
export default function Logo({ dark = false, size = 40 }) {
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div
        className="relative rounded-[13px] bg-navy shadow-sm"
        style={{ width: size, height: size, transform: "rotate(-9deg)" }}
      >
        <div className="absolute inset-0 flex items-center justify-center gap-[3px]">
          <span className="block w-[3.5px] rounded-full bg-lime" style={{ height: size * 0.28 }} />
          <span className="block w-[3.5px] rounded-full bg-lime" style={{ height: size * 0.45 }} />
          <span className="block w-[3.5px] rounded-full bg-lime" style={{ height: size * 0.62 }} />
        </div>
      </div>
      <span
        className={`font-grotesk font-bold tracking-tight ${dark ? "text-cream" : "text-navy"}`}
        style={{ fontSize: size * 0.5 }}
      >
        CallRetrieve
      </span>
    </div>
  );
}
